import React from 'react';
import { Calendar } from 'lucide-react';
import { formatCalendarDate, getTodayInBookingTimeZone, daysBetweenCivilDates, formatDateForApi } from '../../utils/bookingDates';
import { GOLD } from '../../constants/booking';

const sectionTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  marginBottom: '1rem',
  color: '#F5F0E8',
};

function generateCalendarDays(currentMonth) {
  const days = [];
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();
  const firstDayOfWeek = new Date(year, month, 1).getDay();
  const lastDay = new Date(year, month + 1, 0).getDate();
  for (let i = 0; i < firstDayOfWeek; i++) days.push(null);
  for (let day = 1; day <= lastDay; day++) days.push(new Date(year, month, day));
  return days;
}

export default function BookingCalendar({
  currentMonth,
  selectedDate,
  isDayAvailable,
  onDateSelect,
  onPrevMonth,
  onNextMonth,
  isMobile,
}) {
  const days = generateCalendarDays(currentMonth);
  const monthLabel = formatCalendarDate(currentMonth, { month: 'long', year: 'numeric' });

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <h3 style={{ ...sectionTitleStyle, display: 'flex', alignItems: 'center' }}>
        <Calendar size={20} style={{ marginRight: '0.5rem', color: GOLD }} />
        Select Date
      </h3>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <button
          type="button"
          onClick={onPrevMonth}
          style={{ border: 'none', background: 'none', cursor: 'pointer', padding: '0.5rem', color: '#F5F0E8', fontSize: '1.25rem', fontWeight: '600' }}
        >
          ‹
        </button>
        <h4 style={{ fontSize: '1.125rem', fontWeight: '600', margin: 0, color: '#F5F0E8' }}>
          {monthLabel}
        </h4>
        <button
          type="button"
          onClick={onNextMonth}
          style={{ border: 'none', background: 'none', cursor: 'pointer', padding: '0.5rem', color: '#F5F0E8', fontSize: '1.25rem', fontWeight: '600' }}
        >
          ›
        </button>
      </div>

      <div
        className="dd-calendar-grid"
        style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: isMobile ? '0.25rem' : '0.5rem' }}
      >
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
          <div
            key={day}
            className="dd-cal-day-label"
            style={{ textAlign: 'center', fontSize: '0.875rem', fontWeight: '600', color: '#F5F0E8', padding: '0.5rem' }}
          >
            {day}
          </div>
        ))}

        {days.map((date, index) => {
          if (!date) return <div key={`empty-${index}`} style={{ padding: '0.75rem' }} />;

          const isPast = daysBetweenCivilDates(getTodayInBookingTimeZone(), formatDateForApi(date)) < 0;
          const isSelected = selectedDate && selectedDate.toDateString() === date.toDateString();
          const isAvailable = isDayAvailable(date);
          const disabled = !isAvailable || isPast;

          return (
            <button
              key={formatDateForApi(date)}
              type="button"
              onClick={() => !disabled && onDateSelect(date)}
              disabled={disabled}
              style={{
                border: isSelected ? `2px solid ${GOLD}` : '1px solid #4b5563',
                borderRadius: '0.5rem',
                padding: isMobile ? '0.5rem' : '0.75rem',
                backgroundColor: isSelected ? GOLD : disabled ? '#0a0a0a' : '#1a1a1a',
                color: isSelected ? '#000000' : disabled ? '#6b7280' : '#F5F0E8',
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                fontWeight: '600',
                opacity: disabled ? 0.4 : 1,
              }}
            >
              {date.getDate()}
            </button>
          );
        })}
      </div>
    </div>
  );
}
